import { fastlyHtml } from './fastly';
import { nodeHtml } from './node';
import { nginxHtml } from './nginx';
import { apacheHtml } from './apache';
import { magento2Html } from './magento-2';
import { rubyHtml } from './ruby';
import { nextJsHtml } from './NextJS';
import { iisHtml } from './iis';
import { cloudflareHtml } from './cloudflare';
import { nuxtHtml } from './nuxt';
import { dockerHtml } from './docker';
import { firebaseHtml } from './firebase';
import { hapiHtml } from './hapi';
import { koaHtml } from './koa';
import { djangoHtml } from './django';
import { aspnetCoreHtml } from './aspnet-core';
import { springHtml } from './spring';
import { laravelHtml } from './laravel';
import { lovableFreeHtml } from './lovable-free';
import { lovablePaidHtml } from './lovable-paid';
import { akamaiHtml } from './akamai';
import { bubbleHtml } from './bubble';

const DOCS = {
  cloudflare: {
    html: cloudflareHtml,
  },
  fastly: {
    html: fastlyHtml,
  },
  node: {
    html: nodeHtml,
  },
  nginx: {
    html: nginxHtml,
  },
  apache: {
    html: apacheHtml,
  },
  'magento-2': {
    html: magento2Html,
  },
  ruby: {
    html: rubyHtml,
  },
  NextJS: {
    html: nextJsHtml,
  },
  iis: {
    html: iisHtml,
  },
  nuxt: {
    html: nuxtHtml,
  },
  docker: {
    html: dockerHtml,
  },
  firebase: {
    html: firebaseHtml,
  },
  hapi: {
    html: hapiHtml,
  },
  koa: {
    html: koaHtml,
  },
  django: {
    html: djangoHtml,
  },
  'aspnet-core': {
    html: aspnetCoreHtml,
  },
  spring: {
    html: springHtml,
  },
  laravel: {
    html: laravelHtml,
  },
  'lovable-free': {
    html: lovableFreeHtml,
  },
  'lovable-paid': {
    html: lovablePaidHtml,
  },
  akamai: {
    html: akamaiHtml,
  },
  bubble: {
    html: bubbleHtml,
  },
};

export function getDocument(integrationType) {
  return DOCS[integrationType];
}
